export default __webpack_public_path__ + "static/media/Path3504.fd20e151.svg";